import { useCallback, useState } from 'react';

/**
 * useBooleanState hook.
 * Creates boolean hook state with common used assigned callbacks.
 * @func useBooleanState
 * @arg {boolean} initValue - initial value of the state.
 * @returns {array} value with callbacks
 *
 * @example
 * const [isModalOpened, open, close] = useBooleanState();
 * ...
 * /// destructuring example
 * const [isModalOpened,,,toggle] = useBooleanState();
 */
export const useBooleanState = (initValue = false) => {
  const [value, setValue] = useState(initValue);

  const setTrue = useCallback(() => setValue(true), [setValue]);
  const setFalse = useCallback(() => setValue(false), [setValue]);
  const toggle = useCallback(() => setValue(val => !val), [setValue]);

  return [value, setTrue, setFalse, toggle, setValue] as const;
};
